import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppComponent } from './app.component';
import { AuthenticationModule } from './authentication/authentication.module';
import { ModalModule } from 'hsg';
import { AuthUserDetailsComponent } from './authentication/auth-user-details/auth-user-details.component';
import { AuthUserOtpComponent } from './authentication/auth-user-otp/auth-user-otp.component';
import { AuthIssueDateComponent } from './authentication/auth-issue-date/auth-issue-date.component';
import { AuthValidateDetailsComponent } from './authentication/auth-validate-details/auth-validate-details.component';
import { AuthAuthenticateMethodComponent } from './authentication/auth-authenticate-method/auth-authenticate-method.component';
import { AuthChangePasswordComponent } from './authentication/auth-change-password/auth-change-password.component';
import { AuthUserActivationComponent } from './authentication/auth-user-activation/auth-user-activation.component';
import { AuthEndProcessComponent } from './authentication/auth-end-process/auth-end-process.component';
import { AuthCreditCardComponent } from './authentication/auth-credit-card/auth-credit-card.component';
import { AuthPermanentPasswordComponent } from './authentication/auth-permanent-password/auth-permanent-password.component';
import { AuthCustomerServiceComponent } from './authentication/auth-customer-service/auth-customer-service.component';
import { AuthOpenCallsComponent } from './authentication/auth-open-calls/auth-open-calls.component';
import { AuthSuccessRegistrationComponent } from './authentication/auth-success-registration/auth-success-registration.component';
import { AuthLoaderComponent } from './authentication/auth-loader/auth-loader.component';
import { AppConfig } from './app.config';
import { AuthStrictIdChoiceComponent } from './authentication/auth-strict-id-choice/auth-strict-id-choice.component';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AuthenticationModule,
    ModalModule
  ],
  providers: [AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    }],
  entryComponents:
    [
      AuthUserDetailsComponent,
      AuthUserOtpComponent,
      AuthValidateDetailsComponent,
      AuthIssueDateComponent,
      AuthAuthenticateMethodComponent,
      AuthChangePasswordComponent,
      AuthUserActivationComponent,
      AuthEndProcessComponent,
      AuthCreditCardComponent,
      AuthPermanentPasswordComponent,
      AuthCustomerServiceComponent,
      AuthOpenCallsComponent,
      AuthSuccessRegistrationComponent,
      AuthLoaderComponent,
      AuthStrictIdChoiceComponent
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
